module.exports = __webpack_public_path__ + "web-assets/img/swiper.7e2e401f.png";